import { useNotificationsQuery } from "@src/__generated__/graphql";
import { useEffect } from "react";
import type { NotificationsStore } from "../store";

/**
 * Fetch notifications for Table
 */
export const useFetchNotifications = (store: NotificationsStore) => {
  const { loading, refetch } = useNotificationsQuery({
    variables: {
      ...store.queryParams,
      groups: store.notificationGroups,
      read: store.showReadNotifications ? undefined : false,
    },
    notifyOnNetworkStatusChange: true,
    onCompleted({ notifications }) {
      if (notifications) {
        store.setNotifications({
          notifications: {
            data: notifications.data.map((notification) => ({
              ...notification,
              read_at: notification.read_at
                ? new Date(notification.read_at)
                : null,
              created_at: notification.created_at
                ? new Date(notification.created_at)
                : null,
            })),
            paginatorInfo: notifications.paginatorInfo,
          },
        });
      }
    },
  });
  store.refetch = refetch;

  useEffect(() => {
    refetch();
  }, [store.notificationGroups.length]);

  useEffect(() => {
    store.setLoading(loading);
  }, [loading]);

  // refetch every 30 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      refetch();
    }, 30000);
    return () => clearInterval(interval);
  }, []);
};
